import { getAPI } from "../services/api";

export const getAllowedStoresList = async (storeId) => {
  const route = `StoreList`
  const response = getAPI(route, [{storeId: storeId}])
  return response;
}